module.exports = __webpack_public_path__ + "media/images/logo/logo_dokanto_4two-fca102df71fc669d9dcdac7e84d00e1a.svg";